import React from 'react'
import { styled } from 'styled-components'

const GRADIENT_ID = 'premium-pair-icon-gradient'
const svg = document.createElement('div')
svg.style.height = '0'
svg.style.width = '0'
svg.style.pointerEvents = 'none'
svg.innerHTML = `
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="${GRADIENT_ID}">
        <stop offset="0%" stop-color="var(--subscriptionGradientFrom-9)" />
        <stop offset="100%" stop-color="var(--subscriptionGradientTo-9)" />
      </linearGradient>
    </defs>
  </svg>

`
document.body.appendChild(svg)

type Props = {
  radius: number
  size: number
}

export const PairIconPremiumOutline: React.FC<Props> = ({ size, radius }) => {
  return (
    <Root
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      style={{
        position: 'absolute',
        inset: 0,
      }}
    >
      <rect
        x="0.5"
        y="0.5"
        width={size - 1}
        height={size - 1}
        fill="none"
        rx={radius}
        ry={radius}
        strokeWidth={1}
        stroke={`url(#${GRADIENT_ID})`}
      />
    </Root>
  )
}

const Root = styled.svg`
  position: absolute;
  inset: 0;
`
